import { styled, css } from "styled-components";
import { EditorContentWrapper } from "@admin/config/overrides/fieldTypes/MarkdownEditor/children/EditorContent/styles";

export const TextEditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.default[200]};
  border-radius: 4px;
  overflow: clip;
`;

export const TextEditorTips = styled.div`
  padding: 8px;
  font-size: 14px;
  display: flex;
  gap: 4px;
  flex-direction: column;
  letter-spacing: 0.05em;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.default[500]};
`;
